import { connect } from 'react-redux'
import { createItem } from 'components/Items/actions'
import { setItemsCreationFormIsEmpty, setItemsCreationFormIsFocused} from './actions'
import component from './component'


const mapStateToProps = state => ({
    language: state.app.language
})

export default connect(
    mapStateToProps,
    {
        createItem,
        setItemsCreationFormIsEmpty,
        setItemsCreationFormIsFocused
    }
)(component)
